import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleTableFilterSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle opacity={0.88} cx={28} cy={28} r={28} fill="#56A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 16c-.83 0-1.5.67-1.5 1.5V21h26v-3.5c0-.83-.67-1.5-1.5-1.5h-23zM41 22.8H15v13.7c0 .83.67 1.5 1.5 1.5h23c.83 0 1.5-.67 1.5-1.5V22.8z"
        fill="#fff"
      />
      <circle cx={38} cy={36} r={9} fill="#8F9DD6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.08 32.5h-8.16a.42.42 0 00-.3.72l3.26 3.25v3.62c0 .14.06.27.17.35l1.41.98c.28.2.66 0 .66-.34v-4.6l3.26-3.26a.42.42 0 00-.3-.72z"
        fill="#fff"
      />
    </svg>
  );
}

SvgPicCircleTableFilterSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleTableFilterSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleTableFilterSelected svgRef={ref} {...props} />
));
export default ForwardRef;
